import { useTranslation } from "next-i18next";
import Text from "ab-text";

import "./ab-premios.scss";

const Premios = ({ wine, premios, i18n }) => {
  const { t } = useTranslation("common", { i18n });
  if (wine) {
    return (
      <div className={`ab-premios${wine ? " wine" : ""}`}>
        <Text element="h2">{t("premios")}</Text>
        <div>
          {premios?.map((itm) => (
            <div>
              {itm?.imagen?.mediaItemUrl ? (
                <div>
                  <img src={itm?.imagen?.mediaItemUrl} alt={itm.nombre} />
                </div>
              ) : null}
              <Text element="span" className="title">
                {itm.nombre}
              </Text>
            </div>
          ))}
        </div>
      </div>
    );
  }
  return (
    <div className={`ab-premios${wine ? " wine" : ""}`}>
      <Text element="h2">{t("premios")}</Text>
      <div>
        <div>
          <div>
            <img
              src={`/images/estrella_michelin.svg`}
              alt={t("estrella-michelin")}
            />
          </div>
          <Text element="span" className="title">
            {t("estrella-michelin")}
          </Text>
        </div>

        <div>
          <div>
            <img
              src={`/images/estrella_verde_michelin.svg`}
              alt={t("estrella-verde")}
            />
          </div>
          <Text element="span" className="title">
            {t("estrella-verde")}
          </Text>
        </div>

        <div>
          <div>
            <img src={`/images/repsol.svg`} alt={t("soles-repsol")} />
            <img src="/images/repsol.svg" alt={t("soles-repsol")} />
          </div>

          <Text element="span" className="title">
            {t("soles-repsol")}
          </Text>
        </div>
      </div>
    </div>
  );
};

export default Premios;
